var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMingcuteCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1515_239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.1206L17.303 19.4246C17.5844 19.706 17.966 19.8641 18.364 19.8641C18.7619 19.8641 19.1436 19.706 19.425 19.4246C19.7064 19.1432 19.8645 18.7616 19.8645 18.3636C19.8645 17.9657 19.7064 17.584 19.425 17.3026L14.12 11.9996L19.424 6.69662C19.5632 6.55729 19.6737 6.39189 19.749 6.20987C19.8244 6.02785 19.8631 5.83277 19.8631 5.63577C19.8631 5.43877 19.8242 5.24371 19.7488 5.06172C19.6733 4.87974 19.5628 4.71439 19.4235 4.57512C19.2841 4.43586 19.1187 4.3254 18.9367 4.25005C18.7547 4.1747 18.5596 4.13595 18.3626 4.13599C18.1656 4.13604 17.9706 4.17489 17.7886 4.25032C17.6066 4.32575 17.4412 4.43629 17.302 4.57562L12 9.87862L6.69697 4.57562C6.55867 4.43229 6.3932 4.31794 6.21024 4.23924C6.02727 4.16055 5.83046 4.11907 5.63129 4.11725C5.43212 4.11543 5.23459 4.15329 5.05021 4.22862C4.86583 4.30395 4.6983 4.41526 4.55739 4.55603C4.41649 4.6968 4.30503 4.86422 4.22952 5.04853C4.15401 5.23284 4.11597 5.43034 4.1176 5.62951C4.11924 5.82868 4.16053 6.02553 4.23905 6.20857C4.31758 6.39161 4.43177 6.55718 4.57497 6.69562L9.87997 11.9996L4.57597 17.3026C4.29458 17.584 4.13649 17.9657 4.13649 18.3636C4.13649 18.7616 4.29458 19.1432 4.57597 19.4246C4.85737 19.706 5.23902 19.8641 5.63697 19.8641C6.03492 19.8641 6.41658 19.706 6.69797 19.4246L12 14.1196V14.1206Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteCloseFill);
export default __webpack_public_path__ + "static/media/mingcute_close-fill.a8a944514f5d691efa6250ec8b8d5e50.svg";
export { ForwardRef as ReactComponent };